<template>
  <b-form-group :id="`${id}_Group`" :label="labelText" :label-for="id" :class="{required: isRequired, 'is-invalid': isValid != null && !isValid}"
    :description="description">
    <template slot="label"><span class="label">{{labelText}}</span><i v-if="helpText" class="fas fa-question-circle help-icon" v-b-popover.hover.right.html="helpText" :title="helpTitle"></i></template>
    <the-mask :id="id" :type="type" :class="{'form-control': true, 'is-valid': isValid, 'is-invalid': isValid != null && !isValid}" :value="value" :mask="mask" :masked="masked" :required="isRequired" :aria-describedby="`${id}_Feedback`" :placeholder="placeholder" @input="input"></the-mask>
    <b-form-invalid-feedback :id="`${id}_Feedback`"><slot name="feedback"></slot></b-form-invalid-feedback>
  </b-form-group>
</template>

<script>
import { TheMask } from "vue-the-mask";
import helpers from "../helpers";

export default {
  mixins: [helpers],
  components: { TheMask },
  props: {
    type: {
      type: String,
      default: "text"
    },
    mask: {
      type: String,
      required: true,
      default: ""
    },
    masked: {
      type: Boolean,
      required: false,
      default: true
    }
  }
};
</script>

<style>
</style>
